module.exports = __webpack_public_path__ + "img/summary_battery_export.5fbd1794.svg";